import React from 'react';

// The caption that sets the months before the Jira conventions apart inside a period picker.
export default function BoundaryDivider({ label }: { label: string }) {
  return (
    <div className="mb-1.5 mt-2 flex items-center gap-2 first:mt-0" aria-hidden="true">
      <span className="text-[0.6875rem] font-medium uppercase tracking-wide text-gray-600">{label}</span>
      <span className="h-px flex-1 bg-gray-200" />
    </div>
  );
}
